
function callHandler(obj, handler, next) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var ret = handler.call.apply(handler, [obj].concat(args));
  if (!next || typeof next !== 'function') {
    return;
  }
  if (ret && ret.then) {
    ret.then(function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      next.call.apply(next, [obj].concat(args));
    });
  } else {
    next.call.apply(next, [obj].concat(args));
  }
}

/**
 * 给某个处理函数添加hook能力
 * @param {String} hookName
 * @param {Function} handler
 * @param {Object} preset
 * {
 *   pre: () => { // run beafore hook},
 *   next: () => { // run after hook return}
 * }
 */
function hook(hookName, handler) {
  var preset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { pre: null, next: null };

  if (!this.__hooks) {
    this.__hooks = {};
  }
  !this.__hooks[hookName] && (this.__hooks[hookName] = null);
  return function () {
    var _this = this,
        _arguments = arguments;

    if (preset.pre) {
      try {
        var _preset$pre;

        (_preset$pre = preset.pre).call.apply(_preset$pre, [this].concat(Array.prototype.slice.call(arguments)));
      } catch (e) {
        e.message = '[pluginName: ' + this.pluginName + ':' + hookName + ':pre error] >> ' + e.message;
        throw e;
      }
    }
    if (this.__hooks && this.__hooks[hookName]) {
      try {
        var _hooks$hookName;

        var preRet = (_hooks$hookName = this.__hooks[hookName]).call.apply(_hooks$hookName, [this].concat(Array.prototype.slice.call(arguments)));
        if (preRet) {
          if (preRet.then) {
            preRet.then(function (isContinue) {
              if (isContinue) {
                callHandler.apply(undefined, [_this, handler, preset.next].concat(Array.prototype.slice.call(_arguments)));
                // handler.call(this, ...arguments)
              }
            }).catch(function (e) {
              throw e;
            });
          } else {
            callHandler.apply(undefined, [this, handler, preset.next].concat(Array.prototype.slice.call(arguments)));
            // handler.call(this, ...arguments)
          }
        }
      } catch (e) {
        e.message = '[pluginName: ' + this.pluginName + ':' + hookName + '] >> ' + e.message;
        throw e;
      }
    } else {
      callHandler.apply(undefined, [this, handler, preset.next].concat(Array.prototype.slice.call(arguments)));
    }
  }.bind(this);
}

/**
 * 添加hooks
 * @param {String} 支持的hook名称
 * @param {Function} 具体的处理函数
 */
function useHooks(hookName, handler) {
  var __hooks = this.__hooks;

  if (!__hooks.hasOwnProperty(hookName)) {
    console.warn('has no supported hook which name [' + hookName + ']');
    return false;
  }
  __hooks && (__hooks[hookName] = handler);
  return true;
}

/**
 * 给某个插件添加hooks
 * @param {String} pluginName
 * @param  {...any} args
 */
function usePluginHooks(pluginName) {
  if (!this.plugins || !this.plugins[pluginName.toLowerCase()]) {
    return;
  }
  var plugin = this.plugins[pluginName.toLowerCase()];

  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  plugin.useHooks && plugin.useHooks.apply(plugin, args);
}

/**
 * hook装饰器，为某个实例添加usePluginHooks/hook/useHooks的能力
 * @param {*} instance
 */
function hooksDescriptor(instance) {
  instance.__hooks = {};
  Object.defineProperty(instance, 'hooks', {
    get: function get() {
      return Object.keys(instance.__hooks).map(function (key) {
        if (instance.__hooks[key]) {
          return key;
        }
      });
    }
  });
  instance.hook = hook.bind(instance);
  instance.useHooks = useHooks.bind(instance);
  if (instance.plugins) {
    instance.usePluginHooks = usePluginHooks.bind(instance);
  }
}

export { hooksDescriptor as default };